/*
 * ****************************************************************************
 * Copyright (C) 2018-2018, All rights reserved.
 * Project: chessmate
 * Created On: March 23rd, 2018
 * Last Modified: March 23rd, 2018
 * ****************************************************************************
 */

import * as React from 'react';
import { RenderPieceFunction } from './chessboard';
import { ChessRenderInfo } from './chessTypes';
import * as deepEqual from 'deep-equal';

export interface ChessSquareLabel {
  type: string;
  className?: string;
  style?: React.CSSProperties;
  text?: string;
}

/** ChessSquareProps - Properties */
export interface ChessSquareProps {
  renderData: ChessRenderInfo;
  renderPiece: RenderPieceFunction;
  squareProps?: React.HTMLProps<HTMLDivElement>;
  labels?: ChessSquareLabel[];
}

/** ChessSquare */
export class ChessSquareComponent extends React.Component<ChessSquareProps> {
  constructor(props: ChessSquareProps, ctx: any) {
    super(props, ctx);
  }

  shouldComponentUpdate(nextProps: ChessSquareProps, nextState: any) {
    return !deepEqual(this.props, nextProps);
  }

  render() {
    const { renderData, renderPiece, labels, squareProps } = this.props;
    const { square, piece } = renderData;
    const { className, ...props } = squareProps || { className: undefined };
    const classes = [
      'square',
      `square-${square.color}`,
      `square-${square.file}${square.rank}`,
      className
    ].filter(x => x);

    const pieceText = piece ? (piece.color === 'w' ? piece.type.toUpperCase() : piece.type.toLowerCase()) : '-';
    const label = `${square.file}${square.rank}` + (!!piece ? `-${piece.color}${piece.type}` : '');

    const dataTags = {
      'data-square': `${square.file}${square.rank}`,
    };
    if (piece) { dataTags['data-piece'] = `${piece.color}${piece.type}`; }

    return (
      <div className={classes.join(' ')} {...props} {...dataTags} aria-label={label}>
        {renderPiece(renderData)}
        {!!labels && !!labels.length && labels.map(l => (<div key={l.type} className={l.className} style={l.style}>{l.text}</div>))}
        {!!pieceText && <div className="piece-label">{pieceText}</div>}
      </div>
    );
  }
}

export default ChessSquareComponent;


// WEBPACK FOOTER //
// ./src/components/board/chessSquare.tsx